// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__madtA","tabsBox":"styles_tabsBox__1Slme","createButton":"styles_createButton__18XJi"};